function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#0D3979",
  rx: 2.462
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M11.298 4.8v6.428h1.39V4.8c0-.435.35-.8.772-.8.42 0 .772.365.772.8v6.428h1.39V4.8c0-.435.35-.8.771-.8.421 0 .772.365.772.8v6.428h2.021c.45 0 .8.337.8.772 0 .421-.365.772-.8.772h-2.021V19.2c0 .435-.351.8-.772.8-.421 0-.772-.365-.772-.8v-6.428h-1.39V19.2c0 .435-.35.8-.771.8-.421 0-.772-.365-.772-.8v-6.428h-1.39V19.2c0 .435-.35.8-.772.8-.42 0-.772-.365-.772-.8v-6.428h-1.39V19.2c0 .435-.35.8-.771.8-.421 0-.772-.365-.772-.8v-6.428H4.8c-.45 0-.8-.35-.8-.772 0-.421.35-.772.8-.772h2.021V4.8c0-.435.35-.8.772-.8.421 0 .772.365.772.8v6.428h1.403V4.8c0-.435.351-.8.772-.8.421 0 .758.365.758.8"
}));

var SvgIcUob = function SvgIcUob(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    style: {
      background: "#fff"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcUob, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_uob.eeeb74b5.svg";
export { ForwardRef as ReactComponent };